/* eslint-disable import/prefer-default-export */
/* eslint-disable no-unused-vars */
/* eslint-disable no-await-in-loop */
/* eslint-disable max-len */
// import api from './utils/api';
import { apiCpp as api, apiCppWithoutAuth as apiClient } from './utils/api';
import formatCPProposal from './utils/formatCPProposal';

export const getPricesTraits = async (items, clientAccessToken = null) => {
  const payload = (items || []).map(({
    precoNegociado,
    precoFinalSalvo = null,
    precoRegra,
    precoRegraComAdicionalSalvo = null,
    volume,
    minMissing,
    complementaryAdditional,
    isBlocked = false,
  }) => ({
    volume,
    priceNegotiated: precoNegociado,
    priceFinalSaved: precoFinalSalvo,
    priceRule: precoRegra,
    priceRuleWithAdditionalSaved: precoRegraComAdicionalSalvo,
    minMissing,
    complementaryAdditional,
    isBlocked: !!isBlocked,
  }));

  const precos = await (clientAccessToken
    ? apiClient.post('/api/ClientAccess/CalculatePrices', payload, { headers: { 'X-Client-Token': clientAccessToken } })
    : api.post('/api/ProposalTrait/CalculatePrices', payload))
    .then((response) => response.data);

  return precos.map((preco) => ({
    precoFinal: String(preco.priceFinal),
    precoRegraComAdicional: String(preco.priceRuleWithAdditional),
    adicional: String(preco.additional),
  }));
};

export const getCliente = async (codigo, type) => {
  const res = await api
    .get(`/api/Customer/${type}/${codigo}`)
    .then((response) => response);

  return res;
};

export const getVendedores = async (email) => {
  const params = { take: 0, email };

  const res = await api
    .get('/api/Seller', { params })
    .then((response) => response.data);

  return res;
};

export const getTiposProposta = async () => {
  const params = { take: 0 };

  const res = await api
    .get('/api/ProposalType', { params })
    .then((response) => response.data);

  return res;
};

export const getSegmentos = async () => {
  const params = { take: 0 };

  const res = await api
    .get('/api/Segment', { params })
    .then((response) => response.data);

  return res;
};

export const getPagamentos = async () => {
  const params = { take: 0 };

  const res = await api
    .get('/api/Payment', { params })
    .then((response) => response.data);

  return res;
};

export const getFiliais = async () => {
  const params = { take: 0 };

  const res = await api
    .get('/api/Affiliate', { params })
    .then((response) => response.data);

  return res;
};

export const getCidadesAtendidas = async (filialId) => {
  const params = { take: 0, affiliateId: filialId };

  const res = await api
    .get('/api/ServedCity', { params })
    .then((response) => response.data);

  return res;
};

export const getFamilias = async (withDeleted = true) => {
  const params = { take: 0, withDeleted };

  const res = await api
    .get('/api/TraitFamily', { params })
    .then((response) => response.data);

  return res;
};

export const getEspecificacoes = async (filialId, otherParams = {}, withFamilyDeleted = false) => {
  const params = {
    take: 0,
    affiliateId: filialId,
    ...otherParams,
    withFamilyDeleted,
  };

  const res = await api
    .get('/api/Trait', { params })
    .then((response) => response.data);

  const filters = res.map((trait) => ({ ...trait, description: trait.name, company: trait.name }));

  return filters;
};

export const getTracos = async (familiaId, filialId, otherParams = {}) => {
  const params = {
    take: 0,
    familyTraitId: familiaId,
    affiliateId: filialId,
    ...otherParams,
  };

  const res = await api
    .get('/api/Trait', { params })
    .then((response) => response.data);

  return res;
};

export const getBombas = async (filialId, otherParams = {}) => {
  const params = {
    take: 0,
    affiliateId: filialId,
    ...otherParams,
  };

  const res = await api
    .get('/api/Bomb', { params })
    .then((response) => response.data);

  return res;
};

export const getTracoFilial = async (tracoId, filialId, distance) => {
  const res = await api
    .get(`/api/AffiliateTrait/Trait/${tracoId}/Affiliate/${filialId}`, { params: { distance } })
    .then((response) => response.data);

  return res;
};

export const getBombaFilial = async (bombId, filialId) => {
  const res = await api
    .get(`/api/AffiliateBomb/Bomb/${bombId}/Affiliate/${filialId}`)
    .then((response) => response.data);

  return res;
};

export const getAlcada = async (desconto, isInclusion = false, approvalSchemeId = null) => {
  const res = await api
    .get(`/api/HierarchyTrait/Discount/${desconto}`, { params: { inclusion: isInclusion, approvalSchemeId } })
    .then((response) => response);

  return res;
};

export const getAlcadaTraco = async (desconto, isInclusion = false, approvalSchemeId = null) => {
  const res = await api
    .get(`/api/HierarchyTrait/Discount/${desconto}/Full`, { params: { inclusion: isInclusion, approvalSchemeId } })
    .then((response) => response);

  return res;
};

export const getAlcadaMargem = async (margem, isInclusion = false, approvalSchemeId = null) => {
  const res = await api
    .get(`/api/HierarchyMargin/Margin/${margem}/Full`, { params: { inclusion: isInclusion, approvalSchemeId } })
    .then((response) => response);

  return res;
};

export const getAlcadaBomba = async (desconto, isInclusion = false, approvalSchemeId = null) => {
  const res = await api
    .get(`/api/HierarchyBomb/Discount/${desconto}/Full`, { params: { inclusion: isInclusion, approvalSchemeId } })
    .then((response) => response);

  return res;
};

export const getAlcadaPagamento = async (volume, diasPagamento, approvalSchemeId = null) => {
  const res = await api
    .get(`/api/HierarchyPayment/Volume/${volume}/Days/${diasPagamento}/Full`, { params: { approvalSchemeId } })
    .then((response) => response);

  return res;
};

export const listAlcadaTraco = async (approvalSchemeId = null) => {
  const res = await api
    .get('/api/HierarchyTrait/', { params: { take: 0, skip: 0, approvalSchemeId } })
    .then((response) => response?.data || response);

  return res;
};

export const listAlcadaBomba = async (approvalSchemeId = null) => {
  const res = await api
    .get('/api/HierarchyBomb/', { params: { take: 0, skip: 0, approvalSchemeId } })
    .then((response) => response?.data || response);

  return res;
};

export const postContract = async (contractFields) => {
  const res = await api
    .post('/api/Contract', contractFields)
    .then((response) => response.data);
  return res;
};

export const postContractClientAccess = async ({ contractFields, token }) => {
  const res = await apiClient
    .post('/api/Contract/ClientAccess', contractFields, { headers: { 'X-Client-Token': token } })
    .then((response) => response.data);
  return res;
};

export const getContract = async (proposalId) => {
  const res = await api
    .get(`/api/Contract/${proposalId}`)
    .then((response) => response);

  return res;
};

export const getContractClientAccess = async (token) => {
  const res = await apiClient
    .get('/api/Contract/ClientAccess', { headers: { 'X-Client-Token': token } })
    .then((response) => response);

  return res;
};

export const getParameterContract = async () => {
  const res = await api.get('/api/Contract/Parameters').then((response) => response.data);
  return res;
};

export const getParameterContractClientAccess = async (token) => {
  const res = await apiClient
    .get('/api/Contract/ClientAccess/Parameters', { headers: { 'X-Client-Token': token } })
    .then((response) => response.data);
  return res;
};

export const getParameter = async (parameterName) => {
  const res = await apiClient.get(`/api/Parameter/Busca/${parameterName}`).then((response) => response.data);
  return res;
};

export const getParameterBatch = async (parameterNames) => {
  const res = await api
    .get('/api/Parameter/Batch', {
      params: { names: parameterNames },
      paramsSerializer: (params) => params.names.map((n) => `names=${encodeURIComponent(n)}`).join('&'),
    })
    .then((response) => response.data);
  return res;
};

export const getAdditionalProposal = async (proposalId) => {
  const res = await api.get(`/api/AdditionalProposal?proposalId=${proposalId}`).then((response) => response.data);
  return res;
};

export const getAdditionalProposalClientAccess = async (token) => {
  const res = await apiClient
    .get('/api/AdditionalProposal/ClientAccess', { headers: { 'X-Client-Token': token } })
    .then((response) => response.data);
  return res;
};

export const postProposta = async ({ cppFields: fields, saveAndApproval = false }) => {
  const formatedFields = formatCPProposal(fields, saveAndApproval);

  let res = formatedFields.Id
    ? await api.put('/api/Proposal/', formatedFields)
    : await api.post('/api/Proposal/', formatedFields);

  if (res?.isSuccess && !Array.isArray(res.data?.proposalApprovals)) {
    res = await api.get(`/api/Proposal/${res.data?.id}/all?email=${fields?.accountInfo?.username}`);
  }

  return res;
};

export const downloadPdf = async (pdfHTML) => {
  const res = await api
    .post('/api/Export/PDF', { body: pdfHTML }, { responseType: 'blob' })
    .then((response) => response);

  return res;
};

export const downloadPdfClientAccess = async ({ pdfHTML, token }) => {
  const res = await apiClient
    .post('/api/Export/ClientAccess/PDF', { body: pdfHTML }, { responseType: 'blob', headers: { 'X-Client-Token': token } })
    .then((response) => response);

  return res;
};

export const downloadPaymentLinkJson = async (linkParameters, filename = 'paymentlink') => {
  const res = await api
    .post('/api/Payment/LinkPayment', linkParameters, { responseType: 'blob', params: { fileName: filename } })
    .then((response) => response);

  return res;
};

export const getAllProposta = async (codProposta, email) => {
  const res = await apiClient
    .get(`/api/Proposal/${codProposta}/all?email=${email}`)
    .then((response) => response.data);

  return res;
};

export const getProposta = async (codProposta) => {
  const res = await api
    .get(`/api/Proposal/${codProposta}`)
    .then((response) => response.data);

  let proposalTraits = res?.proposalTraits;
  let proposalBombs = res?.proposalBombs;

  let inclusion;
  if (res?.proposalTraits.some((a) => a.inclusion === true) || res?.proposalBombs.some((a) => a.inclusion === true)) {
    inclusion = true;
    proposalTraits = res?.proposalTraits.filter((a) => a.inclusion === true);
    proposalBombs = res?.proposalBombs.filter((a) => a.inclusion === true);
  } else {
    inclusion = false;
  }

  const isBlocked = (res?.isInApproval || (res?.contrateSap && !inclusion));
  const precosFinaisTraits = await getPricesTraits((proposalTraits || []).map((trait) => ({
    precoNegociado: trait.priceNegotiated,
    precoFinalSalvo: trait.priceFinal,
    volume: trait.volume ? parseFloat(trait.volume) : 1,
    minMissing: res?.proposalEstimate?.affiliate?.minMissing || 0,
    complementaryAdditional: res?.proposalEstimate?.affiliate?.complementaryAdditional || 0,
    isBlocked,
  })));

  const tracos = proposalTraits?.map((trait, idx) => {
    const precoFinal = parseFloat(precosFinaisTraits[idx].precoFinal);

    return {
      codigo: trait?.trait?.code,
      nome: trait?.trait?.name,
      tipo: 'Traço',
      qt: trait?.volume,
      precoUnit: precoFinal,
      precoFinal: parseFloat((precoFinal * (trait.volume || 1)).toFixed(2)),
      volumeMinimo: res?.proposalEstimate?.affiliate?.minMissing,
    };
  });

  const bombas = proposalBombs?.map((bomb, idx) => ({
    codigo: bomb?.bomb?.code,
    nome: bomb?.bomb?.name,
    tipo: 'Bomba',
    qt: bomb?.volume,
    precoUnit: (bomb?.priceNegotiated || 1),
    precoFinal: (bomb?.priceNegotiated || 1)
    * ((bomb?.volume > bomb?.volumeMinimum
      ? bomb?.volume
      : bomb?.volumeMinimum) || 1),
    volumeMinimo: bomb?.volumeMinimum,
  }));

  const produtos = tracos.concat(bombas);

  const final = produtos?.reduce((acc, current) => acc + current.precoFinal, 0);

  const volumeFinal = tracos?.reduce((acc, current) => acc + current.qt, 0);

  const proposta = {
    id: res?.id,
    nome: res?.seller?.name,
    codProposta: res?.code,
    clienteEmpresa: res?.proposalIssuer?.corporateName,
    codCliente: res?.proposalIssuer?.code,
    cliente: res?.proposalInvoicing?.nome,
    endereco: `${res?.proposalInvoicing?.address}, ${res?.proposalInvoicing?.numberAddress} ${res?.proposalInvoicing?.complement ? ` - ${res?.proposalInvoicing?.complement}` : ''}`,
    cidade: res?.proposalInvoicing?.city,
    estado: res?.proposalInvoicing?.uf,
    email: res?.proposalInvoicing?.email,
    telefone: res?.proposalInvoicing?.phone,
    enderecoObra: `${res?.proposalReceiver?.address ? res?.proposalReceiver?.address : ''} ${res?.proposalReceiver?.numberAddress ? `, ${res?.proposalReceiver?.numberAddress}` : ''} ${res?.proposalReceiver?.neighborhood ? `- ${res?.proposalReceiver?.neighborhood}` : ''}`,
    produtos,
    volumeTotal: volumeFinal,
    valorTotal: final,
    data: res,
  };

  return proposta;
};

export const getPropostaStore = async () => {
  const constract = JSON.parse(localStorage.getItem('cppStorage'));

  return constract;
};

export const postColaborador = async (colaboradorFields) => colaboradorFields;

export const postEmissor = async (emissorFields) => emissorFields;

export const postFaturamento = async (faturamentoFields) => faturamentoFields;

export const postRecebedor = async (recebedorFields) => recebedorFields;

export const postFilialCidade = async (filialCidadeFields) => filialCidadeFields;

export const postExportPDF = async (body) => {
  const res = await api.post('/api/Export/PDF', { body });

  return res;
};

export const sendEmail = async (fields) => {
  const formatedFields = new FormData();
  formatedFields.append('Subject', fields.subject);

  if (fields?.attachments?.length && fields?.attachments[0]?.file) {
    formatedFields.append('Attachments', fields.attachments[0].file, fields.attachments[0].filename);
  } else if (fields?.attachments?.length && fields?.attachments[0]?.name) {
    formatedFields.append('Attachments', fields.attachments[0], fields.attachments[0].name);
  }

  if (fields?.userName) {
    formatedFields.append('UserName', fields?.userName);
  }

  if (fields?.userEmail) {
    formatedFields.append('UserEmail', fields?.userEmail);
  }

  if (fields?.ccEmail) {
    formatedFields.append('CcEmail', fields?.ccEmail);
  }

  if (fields?.replyToEmail) {
    formatedFields.append('ReplyToEmail', fields?.replyToEmail);
  }

  if (fields?.proposalId) {
    formatedFields.append('ProposalId', fields?.proposalId);
  }

  formatedFields.append('Body', fields.body);

  let res = { data: null, isSuccess: false };
  if (
    fields.emails
    && fields.emails !== undefined
    && Array.isArray(fields.emails)
  ) {
    for (let i = 0; i < fields?.emails?.length; i += 1) {
      // formatedFields.ToEmail = fields.emails[i];
      formatedFields.append('ToEmail', fields.emails[i]);

      res = await api.post('/api/email/send', formatedFields, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    }
  } else {
    formatedFields.append('ToEmail', fields.emailTo);

    res = await api.post('/api/email/send', formatedFields, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  return res;
};

export const getHistorico = async (params, sellerCode) => {
  const paramsField = {
    ...params,
    s: params.search,
    sellerCode,
    startDate: params?.startDate ? params?.startDate?.split('/')?.reverse()?.join('-') : null,
    endDate: params?.endDate ? params?.endDate?.split('/')?.reverse()?.join('-') : null,
    negotiationDateStart: params?.negotiationDateStart ? params?.negotiationDateStart?.split('/')?.reverse()?.join('-') : null,
    negotiationDateEnd: params?.negotiationDateEnd ? params?.negotiationDateEnd?.split('/')?.reverse()?.join('-') : null,
  };

  const res = await api
    .get('/api/Proposal/History', { params: paramsField })
    .then((response) => response.data);

  return res;
};

export const sendDelegation = async (delegationFields) => {
  const res = await api
    .post('/api/Delegation', delegationFields)
    .then((response) => response);
  return res;
};

export const deleteDelegation = async (id) => {
  const res = await api
    .delete(`/api/Delegation/${id}`)
    .then((response) => response);
  return res;
};

export const getVendedorEmail = async (email) => {
  const res = await api
    .get('/api/Seller/Email', { params: { email } })
    .then((response) => response.data);
  return res;
};

export const getUserTypeByEmail = async (email) => {
  const res = await api
    .get(`/api/Seller/UserType/${email}`)
    .then((response) => response.data);
  return res;
};

export const postAprovar = async (aprovarFields) => {
  const res = await api.post(`/api/ProposalApproval/${aprovarFields.id}`, aprovarFields).then((response) => response.data);
  return res;
};

export const postAprovarClientAccess = async ({ aprovarFields, token }) => {
  const res = await apiClient
    .post('/api/ClientAccess/Aprovar', aprovarFields, { headers: { 'X-Client-Token': token } })
    .then((response) => response.data);
  return res;
};

export const cancelApproval = async (cancelFields) => {
  const res = await api.post(`/api/ProposalApproval/Cancel/${cancelFields.id}`, cancelFields).then((response) => response.data);
  return res;
};

export const getAprovacoes = async (emailSeller, params, homeAccountId = null) => {
  const res = await api.get('/api/ProposalApproval/', {
    params: {
      take: params.take,
      skip: params.skip,
      email: emailSeller,
      homeAccountId,
      search: params.search,
      status: params?.status,
      dateInit: params?.dateInit ? params?.dateInit?.split('/')?.reverse()?.join('-') : null,
      dateEnd: params?.dateEnd ? params?.dateEnd?.split('/')?.reverse()?.join('-') : null,
      proposalTypeId: params.statusNegociacao,
    },
  }).then((response) => response);
  return res;
};

export const getAprovacoesPendetes = async (emailSeller, params, homeAccountId = null) => {
  const res = await api.get('/api/ProposalApproval/ApprovalPending', {
    params: {
      take: params.take,
      skip: params.skip,
      email: emailSeller,
      homeAccountId,
      search: params.search,
      dateInit: params?.dateInit ? params?.dateInit?.split('/')?.reverse()?.join('-') : null,
      dateEnd: params?.dateEnd ? params?.dateEnd?.split('/')?.reverse()?.join('-') : null,
      proposalTypeId: params.statusNegociacao,
    },
  }).then((response) => response);
  return res;
};

export const validateClientCode = async ({ token, code }) => {
  const res = await apiClient.post('/api/ClientAccess/ValidateCode', { token, code });
  return res;
};

export const getPropostaClientAccess = async (token) => {
  const res = await apiClient
    .get('/api/ClientAccess/Proposal', { headers: { 'X-Client-Token': token } })
    .then((response) => response.data);
  return res;
};

export const getAprovadores = async (id) => {
  const res = await api.get(`/api/ProposalApproval/Approvals/${id}`).then((response) => response.data);
  return res;
};

export const postContractApi = async (data) => {
  const res = await api.post('/api/APIContract/', data).then((response) => response);

  return res;
};

export const postContractApiClientAccess = async ({ data, token }) => {
  const res = await apiClient
    .post('/api/APIContract/ClientAccess', data, { headers: { 'X-Client-Token': token } })
    .then((response) => response);

  return res;
};

export const postAdditionalProposal = async (data) => {
  const res = await api.post('/api/AdditionalProposal/', data).then((response) => response.data);
  return res;
};

export const resendContractApi = async (data) => {
  const res = await api.post('/api/APIContract/Resend', data).then((response) => response);

  return res;
};

export const resendContractApiClientAccess = async ({ data, token }) => {
  const res = await apiClient
    .post('/api/APIContract/ClientAccess/Resend', data, { headers: { 'X-Client-Token': token } })
    .then((response) => response);

  return res;
};

export const putContractApi = async ({ id, data }) => {
  const res = await api.put(`/api/APIContract/${id}`, data).then((response) => response);

  return res;
};

export const putContractApiClientAccess = async ({ data, token }) => {
  const res = await apiClient
    .put('/api/APIContract/ClientAccess', data, { headers: { 'X-Client-Token': token } })
    .then((response) => response);

  return res;
};

export const putPaymentLinkApi = async ({ id, data }) => {
  const res = await api.put(`/api/APIContract/${id}/Link`, data).then((response) => response);

  return res;
};

export const putPaymentLinkApiClientAccess = async ({ data, token }) => {
  const res = await apiClient
    .put('/api/APIContract/ClientAccess/Link', data, { headers: { 'X-Client-Token': token } })
    .then((response) => response);

  return res;
};

export const sendAprovacao = async (aprovacaoFields) => {
  const res = await api.post(`/api/ProposalApproval/SendApproval/${aprovacaoFields.id}`, aprovacaoFields).then((response) => response);
  return res;
};

export const reSendAprovacao = async (aprovacaoFields) => {
  const res = await api.post(`/api/ProposalApproval/ReSendApproval/${aprovacaoFields.id}`, aprovacaoFields).then((response) => response);
  return res;
};

export const getPDFAprovacoes = async (id) => {
  const res = await api.get(`/api/Approval/PDF/${id}`, { responseType: 'blob' }).then((response) => response);
  return res;
};

export const getCSVProposta = async (id) => {
  const res = await api.get(`/api/Export/CSV/${id}`, { responseType: 'blob' }).then((response) => response);
  return res;
};

export const updateValidity = async (fields) => {
  const res = await api.post(`/api/Contract/UpdateValidity/${fields.proposalId}`, fields).then((response) => response.data);

  return res;
};

export const updateValidityClientAccess = async ({ fields, token }) => {
  const res = await apiClient
    .post('/api/Contract/ClientAccess/UpdateValidity', fields, { headers: { 'X-Client-Token': token } })
    .then((response) => response.data);

  return res;
};

export const getLastContracts = async (fields) => {
  if (!fields.contractCode) {
    return null;
  }

  const res = await api.get(`/api/Contract/Last/${fields.contractCode}`).then((response) => {
    if (response.data) return response.data;
    return response;
  });
  return res;
};

export const getLastProposal = async (fields) => {
  const res = await api.get(`/api/Proposal/Contract/${fields.contractCode}`).then((response) => {
    if (response.data) return response.data;
    return response;
  });
  return res;
};

export const getMaiorTaxa = async () => {
  const res = await api.get('/api/Payment/HighestTax').then((response) => response.data);
  return res;
};

export const getRecomendacao = async (recomendacaoFields) => {
  const res = await api.post('/api/Proposal/ContractRecommendations', recomendacaoFields).then((response) => response.data);
  return res;
};

export const getCalculoDistanciaFabrica = async (distanceFields) => {
  const res = await api.post('/api/Proposal/DistanceCalcule', distanceFields).then((response) => response);
  return res;
};

export const getCalculoDistancia = async (Distancia, ContratoSAP, volumeTracos, segmentId) => {
  if (!Distancia && Distancia !== 0) return null;

  const res = await api.get('/api/Proposal/Distance', {
    params: {
      Distance: Distancia, ContratoSAP, VolumeTotalTraco: volumeTracos, SegmentId: segmentId,
    },
  }).then((response) => response.data);
  return res;
};

export const getFilialProxima = async (endereco) => {
  const res = await api.get('/api/Affiliate/Nearest', {
    params: {
      ...endereco,
    },
  }).then((response) => response?.data || null);

  return res;
};
export const getDistance = async (filialId, latitude, longitude, recebedorAddr, cidadeId, ibgeReceiverCity) => {
  const params = {
    affiliateId: filialId,
    latitude: latitude || null,
    longitude: longitude || null,
    servedCityId: cidadeId,
    ibgeReceiverCity,
  };
  const { data } = await api.post('/api/ProposalEstimate/Distance', recebedorAddr, { params });
  return data;
};

export const getIsLastProposal = async (proposalId) => {
  const res = await api.get(`/api/Proposal/CheckIsLast/${proposalId}`).then((response) => response.data);

  return res;
};

export const getCoordenates = async () => {
  const res = await api.get('api/AffiliateCoordenate');
  return res;
};

export const getAllPlayers = async () => {
  const res = await api
    .get('/api/Player/', { params: { take: 0 } })
    .then((response) => response?.data || response);

  return res;
};

export const getAllLossCauses = async () => {
  const res = await api
    .get('/api/LossCause', { params: { take: 0 } })
    .then((response) => response?.data || response);

  return res;
};
